module.exports = __webpack_public_path__ + "img/technosoft_shorten_logo.6d77818b.jpg";